var extend = require('../util/extend');

module.exports = extend({}, require('./webview'), require('./navigation'));


//////////////////
// WEBPACK FOOTER
// ../src/events/index.js
// module id = 22
// module chunks = 0 2 4